import { Check, Delete } from "@mui/icons-material"
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material"
import React, { FC, useId } from "react"
import { IUrlButtonData, UrlButtonFieldErrors } from "."

interface IEditUrlButtonProps {
  data: IUrlButtonData
  onChange: (
    patch: Partial<IUrlButtonData>,
    field?: keyof UrlButtonFieldErrors,
  ) => void
  onSave: () => void
  onRemove: () => void
  onInputRef: (
    field: keyof UrlButtonFieldErrors,
    element: HTMLInputElement | null,
  ) => void
  hideIconField?: boolean
  errors: UrlButtonFieldErrors
  error?: string | null
}

const EditUrlButton: FC<IEditUrlButtonProps> = (props) => {
  const { data, errors, onChange } = props
  const styleLabelId = useId()
  return (
    <Stack direction="row" sx={{ width: "100%" }}>
      <Stack spacing={1} sx={{ width: "100%" }}>
        <TextField
          label="Текст"
          value={data.text}
          onChange={(event) => onChange({ text: event.target.value }, "text")}
          inputRef={(element) => props.onInputRef("text", element)}
          error={!!errors.text}
          helperText={errors.text}
          required
          fullWidth
        />
        <TextField
          label="Ссылка"
          value={data.url}
          onChange={(event) => onChange({ url: event.target.value }, "url")}
          inputRef={(element) => props.onInputRef("url", element)}
          error={!!errors.url}
          helperText={errors.url}
          required
          fullWidth
        />
        {!props.hideIconField && (
          <TextField
            label="ID кастомного эмодзи"
            value={data.icon_custom_emoji_id ?? ""}
            onChange={(event) =>
              onChange({
                icon_custom_emoji_id: event.target.value || undefined,
              })
            }
            helperText="Опционально. ID эмодзи для отображения перед текстом"
            fullWidth
          />
        )}
        <FormControl fullWidth>
          <InputLabel id={styleLabelId}>Стиль кнопки</InputLabel>
          <Select
            labelId={styleLabelId}
            value={data.style ?? ""}
            label="Стиль кнопки"
            onChange={(event) =>
              onChange({
                style:
                  (event.target.value as IUrlButtonData["style"]) || undefined,
              })
            }
          >
            <MenuItem value="">
              <em>Не выбрано</em>
            </MenuItem>
            <MenuItem value="primary">Primary (синий)</MenuItem>
            <MenuItem value="success">Success (зелёный)</MenuItem>
            <MenuItem value="danger">Danger (красный)</MenuItem>
          </Select>
        </FormControl>
        {props.error && (
          <Typography color="error" variant="caption" role="alert">
            {props.error}
          </Typography>
        )}
      </Stack>
      <Stack spacing={1}>
        <Button
          aria-label="Удалить кнопку"
          color="error"
          onClick={props.onRemove}
          sx={{ height: "100%" }}
        >
          <Delete />
        </Button>
        <Button
          aria-label="Сохранить кнопку"
          color="success"
          onClick={props.onSave}
          sx={{ height: "100%" }}
        >
          <Check />
        </Button>
      </Stack>
    </Stack>
  )
}

export default EditUrlButton
